module.exports = __webpack_public_path__ + "c227f0b618babc7fb4aaf2204aa73288.png";